// Save bytes already in hand (a fetched export, a client-assembled CSV) to the
// reader's disk. A download is not a navigation, and the object-URL + hidden-anchor
// pattern is the only way a browser accepts in-memory bytes. It lives here because
// `bi` may only import `@bi/shared`.
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Give the browser a beat to start the download before revoking. Revoking
  // synchronously after click() races the download in Safari and leaves the
  // reader with nothing.
  window.setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
